import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { departmentQuerySchema } from './department-query-schema';

export const departmentFormSchema = departmentQuerySchema
  .omit({ name: true, status: true, parent_id: true, description: true, children: true })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
    description: z.string(),
  });
export type DepartmentFormSchema = z.infer<typeof departmentFormSchema>;
